import { fetchWithAuth } from '@shared/utils/auth';

export async function fetchNextPage(url, signal) {
  if (!url) {
    throw new Error('URL для пагинации не указан');
  }
  try {
    const response = await fetchWithAuth(url, { method: 'GET', signal });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при загрузке следующей страницы');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API fetchNextPage error:', error);
    throw error;
  }
}